module.exports = __webpack_public_path__ + "static/media/1101-4.7bb50c83.jpg";